import React, { Component } from 'react';
//import Filter from './FilterService'
// Material components
import { withStyles } from '@material-ui/core/styles';
import compose from 'recompose/compose';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Popover from '@material-ui/core/Popover';
import 'moment/locale/es'
import styles from './styles';
import ObjectiveVertical from './ObjectiveVertical'
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import FilterListIcon from '@material-ui/icons/FilterList';
import Button from '@material-ui/core/Button';

//TEMPLATE QUE CREA GRUPO DE OBJETIVOS
class ObjectiveGroup extends Component {
    constructor(props) {
        super(props)
        //console.log('props', this.props.data)
        //console.log('props', props)
        //console.log(typeof(props.data.titulo_grupo),props.data.orden_grupo, String(props.data.color_global))
        this.InfoObjective = this.InfoObjective.bind(this);
        this.state = {
            isLoading: true,
            listObjectivesDataGroup:this.props.data,
            nameGroupObjectives:this.props.data.titulo_grupo,
            orderGroupObjectives:this.props.data.orden_grupo,
            servicios : [
                { servicio: 'atWeb' , id:0, service:[255,256,257,258,270,271,272,280,282]},
                { servicio: 'atMobile', id:1, service:[700]}],
            listObjectivesFilter:this.props.data,
            colorGroup:null,
            open:false,
            anchor:null
        }
        //console.log(this.state)
    }

    componentDidMount() {
        this.processData();
    }

    static getDerivedStateFromProps( prevState, state) {
        if(prevState.data.titulo_grupo!==state.nameGroupObjectives){
            //console.log('nombres grupos')
            const {data: {titulo_grupo,orden_grupo, ...data}} = prevState;
            //console.log(prevState.data)
            if(typeof(prevState.data.colorGroup)!=="undefined"){
                
                const {data: {titulo_grupo,orden_grupo,colorGroup, ...data}} = prevState;
                //console.log('color indefinido', data)
                return{
                    listObjectivesDataGroup:data,
                    listObjectivesFilter:data, 
                    nameGroupObjectives:prevState.data.titulo_grupo,
                    orderGroupObjectives:prevState.data.orden_grupo,
                }
            }
            //console.log('ed',data, prevState.data.titulo_grupo, prevState.data.orden_grupo)
            return{
                listObjectivesDataGroup:data,
                listObjectivesFilter:data, 
                nameGroupObjectives:prevState.data.titulo_grupo,
                orderGroupObjectives:prevState.data.orden_grupo,
            }
        }
        if(typeof(prevState.data.colorGroup)!=="undefined"){
            //console.log('derived',prevState.data,)
            const {data: {colorGroup,titulo_grupo,orden_grupo, ...data}} = prevState;
            //console.log('derived', data, state.listObjectivesDataGroup)
            if(data!== state.listObjectivesDataGroup){
                const {listObjectivesDataGroup: {colorGroup, ...listObjectivesDataGroup}} = state;
                return{
                    colorGroup:prevState.data.colorGroup,
                    listObjectivesDataGroup:listObjectivesDataGroup,
                    //listObjectivesFilter:data
                } 
            }
            return{
                colorGroup:prevState.data.colorGroup,
                listObjectivesDataGroup:data,
                //listObjectivesFilter:data
            }
        }
        
        return null
    }

    InfoObjective=(value)=>{
        this.props.InfoObjective(value)
    }

    /*componentDidUpdate(prevProps, prevState) {
        //console.log(typeof(this.props.data.colorGroup))
        if(typeof(this.props.data.colorGroup)!=="undefined"){
            this.processData();
        }
    }*/
    
          
    

    processData = () => {
        //console.log(this.state.listObjectivesDataGroup.colorGroup)
        const {listObjectivesDataGroup: {titulo_grupo,orden_grupo, ...listObjectivesDataGroup}} = this.state;
    
        //console.log('process', listObjectivesDataGroup)
        this.setState({
            isLoading:false,
            listObjectivesDataGroup:listObjectivesDataGroup
            
        })
    }

    changeFilterService=(e, value)=>{
        const {listObjectivesFilter: {titulo_grupo,orden_grupo, ...listObjectivesFilter}} = this.state;
        //console.log(ListObjectives)
        var dataFilter=[]
        value.map(filterService=>{
            //console.log('array', filterService)
            Object.keys(listObjectivesFilter).map(ele=>{
                //console.log(listObjectivesFilter[ele].servicio)
                if(filterService.service.includes(listObjectivesFilter[ele].servicio)===true){
                    //console.log('incluye',listObjectivesFilter[ele])
                    dataFilter.push(listObjectivesFilter[ele])
                }
            })
            
        })
        //console.log('filter', dataFilter)
        if(dataFilter.length!==0){
            this.setState({
                listObjectivesDataGroup:dataFilter
            })
        }else{
            this.setState({
                listObjectivesDataGroup:listObjectivesFilter
            })
        }
        
    }
    handleCloseFilter = () => {
        this.setState({
            anchor: null,
            open:false
        });
    };
    openFilter=(event)=>{
        this.setState({
            open:true,
            anchor:event.currentTarget
        })
    }
    click=(e)=>{
        console.log(e)
    }

    render() {
        const {isLoading, servicios, orderGroupObjectives, nameGroupObjectives, listObjectivesDataGroup, colorGroup, open,anchor}=this.state
        const {classes}=this.props
        
        if (isLoading===true) {
            return(
                <Grid container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.contentCircular}>
                    <Grid item lg={12} xl={12}>
                        <Typography
                        className={classes.circular}
                        variant="h6"
                        >
                            <CircularProgress
                            className={classes.circular}
                            variant="indeterminate"
                            size={20}
                            thickness={3}
                            
                            />
                        Cargando Grupos...
                        </Typography>
                    </Grid>
                </Grid>
            )
        }else{
            //console.log('render groups',listObjectivesDataGroup, nameGroupObjectives)
            var widthName=""
            if(window.innerWidth<1920){
                widthName="180px"
            }
            var filterService=""
            if(colorGroup!==null){
                filterService=
                    <Grid container direction="row" justify="center" alignItems="center">
                        <Grid item  xl={11} style={{width:widthName}} >
                            <Typography variant="h6" style={{textAlign:"center", backgroundColor:colorGroup, color:"white", paddingLeft:"4px", paddingRigth:"4px", borderRadius:"14px"}}>
                                {nameGroupObjectives}
                            </Typography>
                        </Grid>
                        <Grid item  xl={1} >
                            <Button style={{paddingRight:"25px", color:"#c0c0c0"}} onClick={this.openFilter}><FilterListIcon /></Button>
                        </Grid>
                        <Popover open={open}
                            anchorEl={anchor}
                            onClose={this.handleCloseFilter}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                                }}
                                transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                                }}    
                            //style={{width:"242px", left: "505px",top:"246px", transformOrigin: "286px 0px"}}
                        >
                            <div style={{width:"300px"}}>
                            <Autocomplete 
                                //className={classes.autocomplete}
                                multiple
                                id={orderGroupObjectives}
                                options={servicios}
                                getOptionLabel={option => option.servicio}
                                onChange={this.changeFilterService}
                                defaultValue={servicios}
                                renderInput={params => (
                                    <TextField 
                                    label="Seleccione"
                                    {...params}
                                    variant="standard"
                                    fullWidth
                                    />
                                )}
                                />
                            </div>
                        </Popover>
                    </Grid>
                
            }
            //console.log('render_grupos', listObjectivesDataGroup, nameGroupObjectives)
            return(
                <div>
                    <div>
                        {filterService}

                    {/*CREA OBJETIVOS TEMPLATE*/}
                    <VerticalTimeline>
                        
                        {Object.keys(listObjectivesDataGroup).map(ele=>(
                            <ObjectiveVertical  data={listObjectivesDataGroup[ele]} key={ele} orderGroup={orderGroupObjectives}  
                                 InfoObjective={this.InfoObjective}/>
                        ))}
                        </VerticalTimeline>
                    </div>
                </div>
            )
        }
   
    }
}
export default
    compose(withStyles(styles))(ObjectiveGroup);